import { type ArrowCtaProps } from '@mc/certificates-design-system'
import { type ButtonKindValue, type ButtonProps } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { SUBSCRIPTION_SIGNUP_HREF } from 'pages/certificates/annualpass/data/subscriptionData'
import { SignUpButton } from 'pages/certificates/components/SignUpButton'

type SubscriptionSignUpCTAProps = {
  kind?: ButtonKindValue
  className?: string
  arrowTheme?: ArrowCtaProps['arrowTheme']
  size?: ButtonProps['size']
  textClassName?: string
}

// Certificates subscription sign-up CTA (the "Get the Pass" button). Delegates
// to SignUpButton so it inherits the shared purchaseClick tracking + enterprise
// handling
export const SubscriptionSignUpCTA = ({
  kind = 'primary',
  className = 'w-full',
  arrowTheme,
  size,
  textClassName,
}: SubscriptionSignUpCTAProps = {}) => {
  const { t } = useTranslation('@mc/certificates')
  const ctaText = t('marketingPages.subscription.hero.cta')

  return (
    <SignUpButton
      kind={kind}
      className={className}
      size={size}
      textClassName={textClassName}
      href={SUBSCRIPTION_SIGNUP_HREF}
      text={ctaText}
      // Pinned: the label rebranded to "Get the Pass" (MCCERTS-2801) but the
      // purchaseClick action keeps its historical value for analytics continuity
      action='Get All Courses'
      arrow
      arrowTheme={arrowTheme}
    />
  )
}
